(() => {
  const normalize = (value) =>
    value
      .toLowerCase()
      .normalize('NFKD')
      .replace(/[^\p{L}\p{N}\s-]/gu, ' ')
      .replace(/\s+/g, ' ')
      .trim();

  const tokenize = (value) => normalize(value).split(/[\s-]+/).filter(Boolean);

  const includesPhrase = (words, phrase) =>
    phrase.length === 0 ||
    words.some((_, start) =>
      phrase.every((word, offset) => words[start + offset] === word)
    );

  const init = (root) => {
    if (root.dataset.helpCenterReady === 'true') return;
    root.dataset.helpCenterReady = 'true';
    document.body.classList.add('rehair-help-center-page');

    const search = root.querySelector('[data-help-search]');
    const searchForm = root.querySelector('[data-help-search-form]');
    const clearButton = root.querySelector('[data-help-clear]');
    const categoryButtons = [...root.querySelectorAll('[data-help-category]')];
    const quickQueries = [...root.querySelectorAll('[data-help-query]')];
    const items = [...root.querySelectorAll('[data-help-item]')];
    const groups = [...root.querySelectorAll('[data-help-group]')];
    const results = root.querySelector('[data-help-results]');
    const empty = root.querySelector('[data-help-empty]');
    const resetButton = root.querySelector('[data-help-reset]');
    let activeCategory = 'getting-started';

    const itemIndexes = new Map(
      items.map((item) => [item, tokenize(item.textContent || '')])
    );

    const update = () => {
      const query = normalize(search?.value || '');
      const queryWords = tokenize(query);
      let visibleCount = 0;

      items.forEach((item) => {
        const categoryMatch =
          activeCategory === 'all' || item.dataset.category === activeCategory;
        const searchMatch = includesPhrase(itemIndexes.get(item), queryWords);
        const visible = categoryMatch && searchMatch;
        item.hidden = !visible;
        if (visible) visibleCount += 1;
      });

      groups.forEach((group) => {
        group.hidden = !group.querySelector('[data-help-item]:not([hidden])');
      });

      const categoryLabel =
        categoryButtons
          .find((button) => button.dataset.helpCategory === activeCategory)
          ?.querySelector('span')
          ?.textContent?.trim() || 'All answers';

      if (results) {
        if (query) {
          results.textContent = `${visibleCount} ${visibleCount === 1 ? 'answer' : 'answers'} for “${search.value.trim()}”`;
        } else if (activeCategory !== 'all') {
          results.textContent = `${visibleCount} answers in ${categoryLabel}`;
        } else {
          results.textContent = 'Showing all 54 answers';
        }
      }

      if (empty) empty.hidden = visibleCount !== 0;
      if (clearButton) clearButton.hidden = !search?.value;
    };

    const selectCategory = (category) => {
      activeCategory = category;
      categoryButtons.forEach((button) => {
        button.setAttribute(
          'aria-pressed',
          String(button.dataset.helpCategory === activeCategory)
        );
      });
      update();
    };

    searchForm?.addEventListener('submit', (event) => {
      event.preventDefault();
      update();
    });

    search?.addEventListener('input', update);
    search?.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && search.value) {
        search.value = '';
        update();
      }
    });

    clearButton?.addEventListener('click', () => {
      if (!search) return;
      search.value = '';
      search.focus();
      update();
    });

    categoryButtons.forEach((button) => {
      button.addEventListener('click', () => {
        selectCategory(button.dataset.helpCategory || 'all');
        root
          .querySelector('[data-help-groups]')
          ?.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });

    quickQueries.forEach((button) => {
      button.addEventListener('click', () => {
        if (!search) return;
        search.value = button.dataset.helpQuery || '';
        selectCategory('all');
        search.focus();
      });
    });

    resetButton?.addEventListener('click', () => {
      if (search) search.value = '';
      selectCategory('all');
    });

    const hashTarget = window.location.hash
      ? root.querySelector(window.location.hash)
      : null;
    if (hashTarget?.tagName === 'DETAILS') {
      hashTarget.open = true;
      hashTarget.scrollIntoView({ block: 'center' });
    }

    update();
  };

  const initAll = () => {
    document.querySelectorAll('[data-rehair-help-center]').forEach(init);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll, { once: true });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();
